// extracted by mini-css-extract-plugin
export var layout = "layout-module--layout--84642";
export var layout__footer = "layout-module--layout__footer--12761";
export var layout__footerInner = "layout-module--layout__footerInner--bbc8a";
export var layout__header = "layout-module--layout__header--f6e07";
export var layout__headerInner = "layout-module--layout__headerInner--75d0c";
export var layout__main = "layout-module--layout__main--14aa1";
export var layout__mainInner = "layout-module--layout__mainInner--24073";